(function()
{
	// Library depencencies
	var DebugOptions = include('springroll.DebugOptions', false),
		TitleState = include('WGBH.TitleState'),
		GameState = include('WGBH.GameState'),
		SuccessState = include('WGBH.SuccessState'),
		LoaderBar = include('WGBH.LoaderBar'),
		AccessibilityManager = include('WGBH.AccessibilityManager'),
		Application = include('springroll.Application'),
		Transition = include('lib.Transition'),
		Display = include('springroll.easeljs.EaselJSDisplay'),
		Sound = include('springroll.Sound');

	var addToImages=function(img, asset)
	{	
		window.images[asset.id] = img;
	};
	
	var createSpriteSheet = function(data, asset)
	{
		LOADED_OBJECTS.sprsheets[asset.id] = new createjs.SpriteSheet(data);
	};

	var app = new Application({
		fps: 60,
		name: 'Which Fish?',
		state: 'title',
		canvasId: 'stage',
		configPath: 'assets/config/config.json',
		manifestsPath: 'assets/config/manifests.json',
		captionsPath: 'assets/config/captions.json',
		display: Display,
		displayOptions:	{
			clearView: true,
		},
		preload:[
			{"id":"title_frame", 
			"src":"assets/images/thickwhiteborder.png",
			"complete":addToImages},
			{"id":"graphics_spr", 
			"src":"assets/images/spritesheets/ui_graphics.json",
			"complete":createSpriteSheet},
			{"id":"waterbg", 
			"src":"assets/images/waterbg.png",
			"complete":addToImages},
			{"id":"successbg", 
			"src":"assets/images/successbg.png",
			"complete":addToImages},
			{"id":"selectionbg", 
			"src":"assets/images/selectionbg.png",
			"complete":addToImages},
			{"id":"grass_spr", 
			"src":"assets/images/spritesheets/grass_anim.json",
			"complete":createSpriteSheet},
			{"id":"plant_spr", 
			"src":"assets/images/spritesheets/plant_anim.json",
			"complete":createSpriteSheet},
			{"id":"ripples_spr", 
			"src":"assets/images/spritesheets/ripples_anim.json",
			"complete":createSpriteSheet},
			{"id":"fishanim_spr", 
			"src":"assets/images/spritesheets/fishanim.json",
			"complete":createSpriteSheet},
			{"id":"bubbleanim_spr", 
			"src":"assets/images/spritesheets/fishbubbles.json",
			"complete":createSpriteSheet},
			{"id":"buttonanim_spr", 
			"src":"assets/images/spritesheets/button_anim.json",
			"complete":createSpriteSheet},
			{"id":"endquack_spr", 
			"src":"assets/images/spritesheets/endquack.json",
			"complete":createSpriteSheet}
		]
	});

	// Log out the qeury options
	if (DEBUG && DebugOptions)
	{
		DebugOptions
			.string('state', 'title, game')
			.boolean('mute', 'mute all sounds')
			.log();
	}

	// App has been initialized
	app.on('init', function()
	{
		var assets = this.config.assets;
		var scaling = this.config.scaling;
		var fla = this.manifests;
	
		// SPANISH LANGUAGE TOGGLE
		this.useSpanish = false;
//		this.useSpanish = true;
		
		// global values
		this.level_num = 1;
		this.correct_answer = '';
		this.correct_resp = [];
		this.success_resp = [];
		this.grass_frames = [];
		this.plant_frames = [];
		this.fish_frames = [];
		this.bg_music_on = true;
		this.capt_on = true;
		
		// set up global variables
		this.click_stops_audio = false;
		
		// load transition here
		this.transition = new Transition();
		this.transition.framerate = 30;
				
		// add loading animation
		this.loader_bar = new LoaderBar();
		this.transition.addChild(this.loader_bar);
		
		// add accessibility manager
		this.acc_mgr = new AccessibilityManager();
		this.acc_mgr.setCaptionParameters('captions', app.config.GAME.CAPTIONS.title);
		this.available_haptic = (app.hasTouch && (typeof navigator.vibrate !== 'undefined'));
		
		// grab reference to canvas element, for setting bg colors
		this.cvstage = document.getElementById('stage');	
		
		// grab reference to caption element
		this.caption_disp = document.getElementById('captions');	

		// Set the states to use
		this.states = {
			title: new TitleState({
				next: 'game',
				preload: assets.title,
				scaling: "panel"
			}),
			game: new GameState({
				next: 'success', 
				previous: 'title',
				scaling: "panel"
			}),
			success: new SuccessState({
				next: 'game', 
				previous: 'game',
				scaling: "panel"
			})			
		};
		
		this.states.title.on('progress', function(progress) {
			app.loader_bar.setbar(progress);
		});		
		
		this.states.game.on('progress', function(progress) {
			app.loader_bar.setbar(progress);
		});
		
	});
	
	// used to start the playback of background music
	app.playBackgroundMusic = function() {
		this.background_music = Sound.instance.play('game_bg_music', {loop: -1});	
		this.background_music.volume = app.config.GAME.GAMEPLAY.bgvolume;
		app.bg_music_on = true;
	};
	
	// used to stop the playback of background music
	app.stopBackgroundMusic = function() {
		this.background_music.stop();
		app.bg_music_on = false;
	};

	// Give window access to the app
	window.app = app;

}());
